import { FeedbackModal } from 'modals';
import type { TDialogKey } from './DialogStore.types';

export const getLegacyDialogMapper = (key: TDialogKey) => {
  switch (key) {
    case 'FeedbackModal':
      return FeedbackModal;
    default:
      return null;
  }
};
